import { useState } from 'react';
import { useToastStore } from '../../store/useToastStore.js';

export function FeedbackForm() {
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const addToast = useToastStore((s) => s.addToast);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!message.trim() || submitting) return;

    setSubmitting(true);
    try {
      const { fetchAuthSession } = await import('aws-amplify/auth');
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      const API_URL = import.meta.env.VITE_API_URL || '';
      const res = await fetch(`${API_URL}/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ message: message.trim() }),
      });

      if (res.ok) {
        setSubmitted(true);
        setMessage('');
        addToast('Feedback sent — thank you!', 'success');
      } else {
        addToast('Failed to send feedback', 'error');
      }
    } catch {
      addToast('Failed to send feedback', 'error');
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <div className="rounded border border-green-200 bg-green-50 p-4 text-center">
        <p className="text-sm text-green-700">✓ Thanks for your feedback! It helps us improve.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="rounded border border-slate-200 p-4 space-y-3">
      <label className="block text-sm font-medium text-slate-700">
        Bug, idea, or just vibes — all welcome.
      </label>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={3}
        maxLength={2000}
        placeholder="What's on your mind?"
        className="w-full rounded border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary-500 resize-y"
      />
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-400">{2000 - message.length} characters remaining</span>
        <button
          type="submit"
          disabled={submitting || !message.trim()}
          className="rounded bg-primary-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50"
        >
          {submitting ? 'Sending…' : 'Send Feedback'}
        </button>
      </div>
    </form>
  );
}
